import React from 'react';
import PropTypes from 'prop-types';
import './notifications.scss';
import { Link, useHistory } from 'react-router-dom';
import { Image, Label } from 'semantic-ui-react';
import moment from 'moment';
import Empty from 'components/common/Empty';
import PageLoader from 'components/common/PageLoader';
import usersIcon from 'assets/images/users.svg';
import coinsIcon from 'assets/images/coins.svg';
import userIcon from 'assets/images/user-notif.svg';
import getCurrentOrg from 'helpers/getCurrentOrg';
import calendarIcon from 'assets/images/calendar-days.svg';
import formatNumber from 'helpers/formatNumber';

const NotificationList = ({ items, loading, onReadNotification }) => {
  const currentOrg = getCurrentOrg();
  const { push } = useHistory();

  if (loading) {
    return <PageLoader loaderContent="Loading notifications..." />;
  }

  if (Array.isArray(items) && items.length === 0) {
    return <Empty message="No notifications" icon="info circle" />;
  }

  return (
    <div className="notification-list">
      <div className="notification-list__items">
        {(items ?? []).map(item => (
          <div
            className={`notification-list__items__item${
              !item.read
                ? ' notification-list__items__item--unread'
                : ''
            }`}
            key={item.id}
            tabIndex="-1"
            onKeyDown={null}
            role="button"
            onClick={() => {
              if (!item.read) {
                onReadNotification(item.request_id);
              }
              push(
                `/organizations/${currentOrg?.id}/requests/${item.request_id}`,
              );
            }}
          >
            <div className="notification-list__items__item__details">
              <div className="notification-list__items__item__details__info">
                <div
                  className={`notification-list__items__item__details__info__name ${
                    !item.read ? 'unread' : ''
                  }`}
                >
                  {item.message.split(/(#\d+)/).map(part => {
                    const match = part.match(/^#(\d+)$/);
                    if (match) {
                      return (
                        <Link
                          key={item.request_id}
                          to={`/organizations/${currentOrg?.id}/requests/${item.request_id}`}
                        >
                          {part}
                        </Link>
                      );
                    }
                    return part;
                  })}
                </div>
                <div className="notification-list__items__item__details__info__numbers">
                  <div className="number-group">
                    {item?.request?.type !== 'group_micro_loan' ? (
                      <Image
                        className="number-group__icon"
                        width={13}
                        src={userIcon}
                      />
                    ) : (
                      <Image
                        className="number-group__icon"
                        width={13}
                        src={usersIcon}
                      />
                    )}

                    <span>
                      <span>
                        {item?.request?.type === 'group_micro_loan'
                          ? item?.group?.name
                          : `${item?.request?.user?.first_name} ${item?.request?.user?.last_name}`}
                      </span>
                    </span>
                  </div>
                  <div className="number-group">
                    <Image
                      className="number-group__icon"
                      width={13}
                      src={coinsIcon}
                    />
                    <span>
                      <span>
                        Rwf {formatNumber(item?.request?.amount)}
                      </span>
                    </span>
                  </div>
                  <div className="number-group">
                    <Image
                      className="number-group__icon"
                      width={13}
                      src={calendarIcon}
                    />
                    <span>
                      <span>
                        {moment(item.created_at).format('MM/DD/YYYY')}
                      </span>
                    </span>
                  </div>

                  <div className="number-group">
                    <Label
                      style={{
                        color: '#029B5D',
                        backgroundColor: 'rgba(76, 208, 128, 0.13)',
                      }}
                    >
                      {item?.request?.admins_approvals?.reduce(
                        (prev, curr) => {
                          if (curr.status === 'accepted') {
                            return prev + 1;
                          }
                          return prev;
                        },
                        0,
                      ) || 0}
                      /3 approvals
                    </Label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

NotificationList.propTypes = {
  items: PropTypes.arrayOf(Object).isRequired,
  loading: PropTypes.bool,
  onReadNotification: PropTypes.func,
};

NotificationList.defaultProps = {
  loading: false,
  onReadNotification: () => null,
};

export default NotificationList;
